import React, { useEffect } from 'react';
import dayjs from 'dayjs';
import cN from 'classnames';
import { SubTitle } from '@components/DetailPage';
import RecommendCards from '@components/DetailPage/RecommendCards';
import { useSelector, useDispatch } from 'react-redux';
import { I_Group } from '@Redux/detail/Group/interfaces';
import * as recommendActions from '@Redux/detail/Recommend/actions';
import { RootState } from '@Redux/detail/store';
import noSimilarImg from '../../../pages/detail/imgs/noSimilar.png';

interface I_RecommendsProps {
    isNoData: boolean;
}

const Recommends: React.FC<I_RecommendsProps> = (props) => {
    const dispatch = useDispatch();
    const recommends = useSelector((state: RootState) => state.recommendReducer);

    useEffect(() => {
        const { travelinfo } = document.getElementById('detailPagePara')!.dataset!;
        const { GroupInfo }: I_Group = JSON.parse(travelinfo!);

        const DateStartVal = GroupInfo.GroupID
            ? dayjs(GroupInfo.GoDate).subtract(7, 'days').format('YYYY-MM-DD')
            : dayjs().format('YYYY-MM-DD');
        const DateEndVal = GroupInfo.GroupID
            ? dayjs(GroupInfo.GoDate).add(90, 'days').format('YYYY-MM-DD')
            : dayjs().add(1, 'year').format('YYYY-MM-DD');

        const reqBody = {
            ShowCount: 10,
            Type: '3',
            Country: 'TW',
            ArriveID: GroupInfo.ArriveID,
            GoDateStart: DateStartVal,
            GoDateEnd: DateEndVal,
            TravelType: GroupInfo.TravelType,
            SimilarNormGroupID: GroupInfo.NormGroupID,
            TourSource: GroupInfo.TourSource,
        };

        dispatch(recommendActions.setRecommends(reqBody));
    }, [dispatch]);

    if (recommends.isLoading) {
        return null;
    }

    return (
        <div className={cN('recommend_wrapper', props.isNoData ? 'noData' : '')}>
            {props.isNoData ? (
                <SubTitle
                    texts={{
                        main: '此產品已過期或下架',
                        sub: '您可以探索其他相似行程，或使用搜尋引擎搜尋！',
                    }}
                />
            ) : (
                <SubTitle texts={{ main: '探索其他行程', sub: 'Recommend' }} />
            )}
            {recommends && recommends?.recommendList?.length > 0 ? (
                <RecommendCards />
            ) : (
                <div className={cN('recommend_no_similar')}>
                    <div className="text_block">
                        <div>很抱歉，目前沒有類似的商品</div>
                        <p>想探索更多行程，請回到搜尋引擎再次搜尋喔 !</p>
                    </div>
                    <div className="img_block">
                        <img src={noSimilarImg} alt="noSimilar.png" loading="lazy" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Recommends;
